const SET_SAVE_DATA = "SET_SAVE_DATA";
const SET_TVL = "SET_TVL";
const SET_INSTALLED_EXTENSION = "SET_INSTALLED_EXTENSION";
const SET_IS_EXTENSION_INSTALLED = "SET_IS_EXTENSION_INSTALLED";
const SET_ACCOUNT_BALANCE = "SET_ACCOUNT_BALANCE";
const SET_SELECTED_ACCOUNT = "SET_SELECTED_ACCOUNT";
const SET_TRANSACTION_TYPE = "SET_TRANSACTION_TYPE";
const SET_STATUS = "SET_STATUS";
const SET_TRANSACTION_STATUS = "SET_TRANSACTION_STATUS";
const SET_WITHDRAW_STATUS = "SET_WITHDRAW_STATUS";
const SET_WITHDRAW_ID = "SET_WITHDRAW_ID";
const SET_CONTRACT_TYPE = "SET_CONTRACT_TYPE";
const SET_TRANSACTION_ID = "SET_TRANSACTION_ID";
const SET_CONNECTED_ACCOUNT_TYPE = "SET_CONNECTED_ACCOUNT_TYPE";
const SET_BLADE_EXTENSION_INSTALLED = "SET_BLADE_EXTENSION_INSTALLED";
const SET_SHOW_WALLET_MODAL = "SET_SHOW_WALLET_MODAL";
const SET_FIRESTORE_DATA = "SET_FIRESTORE_DATA";
const SET_DEFI_DATA = "SET_DEFI_DATA";
const SET_UNDER_MAINTENANCE_DATA = "SET_UNDER_MAINTENANCE_DATA";

export {
  SET_SAVE_DATA,
  SET_TVL,
  SET_INSTALLED_EXTENSION,
  SET_IS_EXTENSION_INSTALLED,
  SET_ACCOUNT_BALANCE,
  SET_SELECTED_ACCOUNT,
  SET_TRANSACTION_TYPE,
  SET_STATUS,
  SET_TRANSACTION_STATUS,
  SET_WITHDRAW_STATUS,
  SET_WITHDRAW_ID,
  SET_CONTRACT_TYPE,
  SET_TRANSACTION_ID,
  SET_CONNECTED_ACCOUNT_TYPE,
  SET_BLADE_EXTENSION_INSTALLED,
  SET_SHOW_WALLET_MODAL,
  SET_FIRESTORE_DATA,
  SET_DEFI_DATA,
  SET_UNDER_MAINTENANCE_DATA,
};
